export default __webpack_public_path__ + "static/assets/med_x_vial.f249c19f.png";